import filter from "lodash/filter";
import uniqBy from "lodash/uniqBy";
import { useSearchStoreContext } from "PFApp/search/search_context";
import { NormalizedKeyword } from "PFReducers/search_reducer/helpers/normalize_keywords";
import { PureCustomValueData } from "PFTypes";
import { useTranslation } from "react-i18next";

import { SmartSuggestionsShell } from "./smart_suggestions_shell";
import { SuggestedFilters } from "./suggested_filters";
import { SuggestedKeywords } from "./suggested_keywords";

export const SmartSuggestions = () => {
  const {
    search: { suggestedKeywords, choosenKeywords }
  } = useSearchStoreContext();
  const { t } = useTranslation("search");
  const suggestibles = getSuggestibles(suggestedKeywords, choosenKeywords);
  const filterSuggestions = getFilterSuggestions(suggestedKeywords, choosenKeywords);

  return (
    <SmartSuggestionsShell empty={suggestibles.length === 0 && filterSuggestions.length === 0}>
      <p>{t("smartSuggestions.description")}</p>

      <SuggestedKeywords items={(suggestibles || []) as unknown as PureCustomValueData[]} />
      <SuggestedFilters items={(filterSuggestions || []) as unknown as PureCustomValueData[]} />
    </SmartSuggestionsShell>
  );
};

const getSuggestibles = (suggestedKeywords: NormalizedKeyword[], choosenKeywords: NormalizedKeyword[]) => {
  const isNotChoosen = (keyword: NormalizedKeyword) =>
    !choosenKeywords.find((other) => other.id === keyword.id);
  const notChoosenKeywords = suggestedKeywords.filter(isNotChoosen);

  return filter(notChoosenKeywords, "match");
};

const getFilterSuggestions = (
  suggestedKeywords: NormalizedKeyword[],
  choosenKeywords: NormalizedKeyword[]
) => {
  // detectables are also suggested but are to be treated as filters
  const detectables = filter(suggestedKeywords, "filterKey");
  const chosen = filter(choosenKeywords, "filterKey");
  return uniqBy(detectables.concat(chosen), "id");
};
